import { IRCLeagueDetailData, RCLeagueDetailTypeEnum } from 'types/coreEntites/Leagues';
import { rcEnums } from 'types/rc.enums';
import { capitalize } from './form';

export function getLeagueTagDetails(data: IRCLeagueDetailData[]) {
	const tagsData: string[] = [];

	// eslint-disable-next-line array-callback-return
	data.map((value: IRCLeagueDetailData, index: number) => {
		switch (value.detailType) {
			// set gender
			case RCLeagueDetailTypeEnum.GENDER:
				if (Number(value.data) === rcEnums.shared.GenderEnum.OTHER) {
					tagsData.push('Coed');
				} else {
					tagsData.push(capitalize(rcEnums.shared.GenderEnum[Number(value.data)].toLowerCase()));
				}
				break;

			// set level of play
			case RCLeagueDetailTypeEnum.LEVELOFPLAY:
				if (Number(value.data) === rcEnums.shared.LevelOfPlayEnum.SEMIPRO) {
					tagsData.push('Semi-pro');
				} else {
					const level = rcEnums.shared.LevelOfPlayEnum[Number(value.data)];
					if (level) {
						tagsData.push(capitalize(level.toLowerCase()));
					}
					// else {
					//   tagsData.push('Other');
					// }
				}
				break;
			case RCLeagueDetailTypeEnum.MINAGE:
				tagsData.push(`${value.data} - ${data[index + 1] && data[index + 1].data}`);
				break;
			// set RCLeagueDetailTypeEnum.FORMAT
			case RCLeagueDetailTypeEnum.FORMAT:
				tagsData.push(`${value.data} vs ${value.data}`);
				break;

			// set RCLeagueDetailTypeEnum.SURFACE
			case RCLeagueDetailTypeEnum.SURFACE:
				if (value.data === 'fieldTurf') {
					tagsData.push('Field Turf');
				} else if (value.data === 'astroTurf') {
					tagsData.push('Astro Turf');
				} else if (value.data === 'sportCourt') {
					tagsData.push('Sport Court');
				} else {
					tagsData.push(capitalize(value.data.toString().toLowerCase()));
				}
				break;

			// set RCLeagueDetailTypeEnum.OTHER
			case RCLeagueDetailTypeEnum.OTHER:
				tagsData.push('Other');
				break;

			// default:
			//   tagsData.push('Other');
			//   break;
		}
	});

	return tagsData;
}
